import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { GameCenterComponentGridAreas } from '../../styles';

export const RightRailContainer = styled.div`
    ${BaseStyle.Mixins.gaps.semiLarge}
    display: flex;
    flex-direction: column;
    grid-area: ${GameCenterComponentGridAreas.rightRail};
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.Surface.border};
    padding: 24px 0;
    height: fit-content;
`;

export const LoaderContainer = styled.div`
    display: none;
    height: fit-content;
    justify-content: center;
    margin-top: 64px;

    ${BaseStyle.Mixins.screenSizes.medium} {
        display: flex;
    }
`;

export const AdContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    grid-area: ${GameCenterComponentGridAreas.ad};
    background: ${({ theme }) => theme.Surface.secondary};
    padding: 32px 0;

    ${BaseStyle.Mixins.screenSizes.large} {
        padding: 14px 0;
    }

    ${BaseStyle.Mixins.screenSizes.extraLarge} {
        padding: 50px 0;
    }
`;
